import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Profile from "./pages/Profile.jsx";
import ContactUs from "./pages/ContactUs.jsx";
import Help from "./pages/Help.jsx";
import Settings from "./pages/Settings.jsx";
import Terms from "./pages/Terms.jsx";
import AboutUs from "./pages/AboutUs.jsx";
import PrivacyPolicy from "./pages/PrivacyPolicy.jsx";
import LastBuildDate from "./pages/LastBuildDate.jsx";
import ConfirmEmail from "./pages/ConfirmEmail.jsx";
import PageNotFound from "./pages/PageNotFound.jsx";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/faq" element={<Help />} />
        <Route path="/contacts" element={<ContactUs />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        <Route path="/last-build-date" element={<LastBuildDate />} />

        <Route path="/confirm-email/:token" element={<ConfirmEmail />} />

        <Route path='*' element={<PageNotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
